import { render, staticRenderFns } from "./ShortlistForm.vue?vue&type=template&id=22f45214&"
import script from "./ShortlistForm.vue?vue&type=script&lang=js&"
export * from "./ShortlistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports